var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ModifyPWD"}},[_c('PersonalPanel',{attrs:{"type":2,"isSingleMode":true,"expire":true},on:{"closeMe":_vm.closeMe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }